import React from "react";
import { WarningAmberRounded as WarningIcon } from "@mui/icons-material";

import { formatCurrency } from "../../../../../../utils";
import { OverdueVariantProps } from "./types";
import { LogPaymentButton } from "./LogPaymentButton";
import {
  NextAmount,
  ApproxRow,
  ApproxGlyph,
  EstBadge,
  OverdueNotice,
  OverdueNoticeText,
  NextFootnote,
} from "./styles";

export const OverdueVariant: React.FC<OverdueVariantProps> = ({
  paymentAmount,
  isApproximatedAmount,
  dueDateLabel,
  onLogPayment,
}) => (
  <>
    <NextAmount data-testid="liability-next-amount">
      {isApproximatedAmount ? (
        <ApproxRow>
          <ApproxGlyph aria-hidden="true">≈</ApproxGlyph>
          <NextAmount data-testid="liability-next-amount">
            {formatCurrency(paymentAmount)}
          </NextAmount>
          <EstBadge>Est.</EstBadge>
        </ApproxRow>
      ) : (
        formatCurrency(paymentAmount)
      )}
    </NextAmount>
    <OverdueNotice>
      <WarningIcon />
      <OverdueNoticeText>
        Was due <strong>{dueDateLabel}</strong>. Log it to keep your balance and
        payoff date accurate.
      </OverdueNoticeText>
    </OverdueNotice>
    <LogPaymentButton onLogPayment={onLogPayment} />
    <NextFootnote>
      Records against the {dueDateLabel} due date — not today
    </NextFootnote>
  </>
);
